module.exports = "/images/lightweight-vehicles.svg?e8ca143877ff62f80238bd5d83b42e3d";